import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import FormField from "layouts/pages/account/components/FormField";

import React from "react";

function Notifications({ accounts, handleFeedback }) {
  const [form, setForm] = React.useState({
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (handleFeedback) {
      handleFeedback(form.subject, form.message);
    }
  };

  return (
    <Card id="notifications">
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Feedbacks</MDTypography>
        </MDBox>
        <MDTypography variant="button" color="text">
          Choose how you receive feedbacks. These feedback settings apply to the things you're
          watching.
        </MDTypography>
      </MDBox>
      <MDBox pb={3} px={3}>
        <MDBox>
          <FormField name="subject" onChange={handleChange} label="Subject" />
        </MDBox>
        <label style={{ fontSize: 12, color: "gray" }}>Message</label>
        <MDBox mt={1}>
          <textarea
            name="message"
            onChange={handleChange}
            rows={5}
            style={{
              borderColor: "#DDD",
              width: "100%",
              padding: 8,
              fontSize: 16,
              fontFamily: "inherit",
            }}
          />
        </MDBox>
        <MDBox ml="auto" mt={2}>
          <MDButton onClick={handleSubmit} variant="gradient" color="dark" size="small">
            Submit
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Notifications;
